const standardBusinessTitles = [
  { jobProfile: 'Product Engineer', jobLevel: 'Senior', title: 'Senior Product Engineer' },
  { jobProfile: 'Product Engineer', jobLevel: 'Staff', title: 'Staff Product Engineer' },
  { jobProfile: 'Product Manager', jobLevel: 'Director', title: 'Product Management, Director' },
  { jobProfile: 'Corporate Relations Manager', jobLevel: 'Director', title: 'Corporate Relations, Director' },
] as const;

export function recommendBusinessTitle(jobProfile?: string, jobLevel?: string): string | undefined {
  if (!jobProfile?.trim()) return undefined;

  return standardBusinessTitles.find((rule) => rule.jobProfile === jobProfile && rule.jobLevel === jobLevel)?.title
    ?? jobProfile;
}
